import * as React from 'react';
const SvgEventAudioVisual = (props) => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#event-audio-visual_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M56.133 108.52h61.742M1.875 108.52h13.097M35.553 117.875a9.355 9.355 0 1 0 0-18.71 9.355 9.355 0 0 0 0 18.71ZM114.133 1.875H5.617a3.742 3.742 0 0 0-3.742 3.742v74.839a3.742 3.742 0 0 0 3.742 3.742h108.516a3.742 3.742 0 0 0 3.742-3.742V5.616a3.742 3.742 0 0 0-3.742-3.741Z" />
      <path d="M44.907 22.456v41.16l35.549-20.58-35.549-20.58Z" />
    </g>
    <defs>
      <clipPath id="event-audio-visual_svg__a">
        <path fill="#fff" d="M0 0h120v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEventAudioVisual;
